<template>
<div class="chapter">
<div class="inner_page">
<p class="p0"> </p>
<p class="p0"><span class="t2">Got the Blues</span></p>
<p class="p0">By Lynn Townsend</p>
<p class="p0"> </p>
<p class="p0">Published by <a href="http://www.jms-books.com" target="_blank"><span class="t3">JMS Books LLC</span></a></p>
<p class="p0">Visit <a href="http://www.jms-books.com" target="_blank"><span class="t3">jms-books.com</span></a> for more information.</p>
<p class="p0"> </p>
<p class="p0">Copyright 2019 Lynn Townsend</p>
<p class="p0">ISBN 9781634869256</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002.vue?1694b7d4